<script>
    export default {
        props: ['pedidoProp'],
        
        watch: {
            pedidoProp() {
                if (this.pedidoProp !== null && typeof this.pedidoProp.id !== 'undefined') {
                    $('#modalDetalhesDocumento').modal()
                } else {
                    $('#modalDetalhesDocumento').modal('hide')
                }
            }
        },
         
        methods: {
            totalAnalises() {
                let valor = 0
                this.pedidoProp.analises.forEach(element => valor += parseFloat(element.valor_amostra));
                return valor
            },

            totalCredDeb(tipo) {
                let valor = 0
                this.pedidoProp.creditos_debitos.forEach(element => valor += (tipo === element.operacao ? parseFloat(element.valor) : 0));
                return valor
            }
        }
    }
</script>

<template>

    <div id="modalDetalhesDocumento" class="modal" role="dialog" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog tamanho-modal">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Detalhes</h4>
                </div>
                <div class="modal-body" v-if="pedidoProp !== null && typeof pedidoProp.id !== 'undefined'">
                    <div class="block">
                        <div class="block-title">
                            <h5>{{ `ANALISES (${pedidoProp.analises.length})` }}</h5>
                        </div>

                        <div class="row">
                            <table border="1" width="100%" class="table table-striped table-bordered table-hover">
                                <tbody>
                                <tr>
                                    <th width="19%">Proprietários</th>
                                    <th width="19%">Arrendatarios</th>
                                    <th width="15%">Remetente</th>
                                    <th width="8%">Tipo</th>
                                    <th width="8%">Registro</th>
                                    <th width="8%">Resultado</th>
                                    <th width="8%" class="text-center">Valor
                                        (R$)
                                    </th>
                                </tr>
                                <tr v-for="(analise, index) in pedidoProp.analises" :key="index">
                                    <td>
                                        <div :key="index" v-for="(proprietario, index) in analise.proprietarios"
                                                    style="margin-bottom: 7px;">
                                            <span v-if="proprietario.tipo == 1">{{ proprietario.nome }}<br>{{ proprietario.cpf }}</span>
                                            <span v-else>{{ proprietario.razao_social }}<br>{{ proprietario.cnpj }}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div :key="index" v-for="(arrendatario, index) in analise.arrendatarios"
                                                    style="margin-bottom: 7px;">
                                                <span v-if="arrendatario.tipo == 1">{{ arrendatario.nome }}<br>{{ arrendatario.cpf }}</span>
                                                <span v-else>{{ arrendatario.razao_social }}<br>{{ arrendatario.cnpj }}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div style="margin-bottom: 7px;" v-if="analise.remetente !== null">
                                                <span v-if="analise.remetente.tipo == 1">{{ analise.remetente.nome }}<br>{{ analise.remetente.cpf }}</span>
                                                <span v-else>{{ analise.remetente.razao_social }}<br>{{ analise.remetente.cnpj }}</span>
                                            </div>
                                        </td>
                                        <td>{{analise.tipo}}</td>
                                        <td>{{analise.registro }}/{{ analise.ano_registro }}</td>
                                        <td>
                                            <div style="margin-bottom: 7px;">
                                                <span v-if="analise.data_resultado_formatada != null">{{ analise.data_resultado_formatada }}</span>
                                            </div>
                                        </td>
                                    <td class="text-center">{{ analise.valor_amostra | formatMoney }}</td>
                                </tr>
                                <tr>
                                    <td colspan="5"></td>
                                    <td class="text-right"><b>Total em analises:</b></td>
                                    <td class="text-center"><b>R$ {{ totalAnalises() | formatMoney }}</b></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="block">
                        <div class="block-title">
                            <h5>CRÉDITOS E DÉBITOS</h5>
                        </div>

                        <div class="row">
                            <table border="1" width="100%" class="table table-striped table-bordered table-hover">
                                <tbody>
                                <tr>
                                    <th width="20%">Operação</th>
                                    <th width="60%">Descrição</th>
                                    <th width="20%" class="text-center">Valor (R$)</th>
                                </tr>
                                <tr v-if="pedidoProp.creditos_debitos.length > 0" v-for="(credDeb, index) in pedidoProp.creditos_debitos" :key="index">
                                    <td>{{credDeb.operacao == 'CREDITO' ? 'Crédito' : 'Débito'}}</td>
                                    <td> <pre class="nl2br">{{ credDeb.descricao }}</pre></td>
                                    <td class="text-center">{{ credDeb.valor | formatMoney }}</td>
                                </tr>
                                <tr v-if="pedidoProp.creditos_debitos.length > 0">
                                    <td class="text-right" colspan="2"><b>Total em créditos:</b></td>
                                    <td class="text-center"><b>R$ {{ totalCredDeb('CREDITO') | formatMoney }}</b></td>
                                </tr>
                                <tr v-if="pedidoProp.creditos_debitos.length > 0">
                                    <td class="text-right" colspan="2"><b>Total em débitos:</b></td>
                                    <td class="text-center"><b>R$ {{ totalCredDeb('DEBITO') | formatMoney }}</b></td>
                                </tr>

                                <tr v-if="pedidoProp.creditos_debitos.length <= 0">
                                    <td class="text-center" colspan="3"><b>Nenhum crédito e débito lançado</b></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-effect-ripple btn-danger" @click="$emit('close')">Fechar</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .nl2br {
        font-family: "Lato", "Helvetica Neue", Helvetica, Arial, sans-serif;
        background: none;
        overflow: hidden;
        padding: 0px;
        margin: 0px;
        border: 0px;
        border-radius: 0px;
    }
</style>